import React, { Component } from "react";
import themeLarge from "../../component/ThemeLarge";

class MetricSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      thresholds: {
        LCP: 2500,
        FID: 100,
        INP: 200,
        CLS: 0.1,
        TTFB: 600,
        FCP: 1800,
      },
    };
  }

  getAverage = (entries) => {
    if (!entries || entries.length === 0) return null;
    const sum = entries.reduce((total, e) => total + Number(e.value || 0), 0);
    return sum / entries.length;
  };

  getColor = (metric, avg) => {
    const threshold = this.state.thresholds[metric];
    if (!avg || !threshold) return "#555";
    return avg > threshold ? themeLarge.colors.primary : "#2e7d32"; // red vs green
  };

  render() {
    const { groupedMetrics } = this.props;

    const metrics = Object.keys(groupedMetrics);

    return (
      <div
        className="row row-cols-1 row-cols-md-3 g-4 mb-4"
        style={{ marginTop: "20px" }}
      >
        {metrics.map((metric) => {
          const avg = this.getAverage(groupedMetrics[metric]);
          return (
            <div className="col" key={metric}>
              <div
                className="card h-100"
                style={{
                  borderLeft: `5px solid ${this.getColor(metric, avg)}`,
                  boxShadow: themeLarge.shadows.standard,
                  borderRadius: "8px",
                }}
              >
                <div className="card-body">
                  <h6 className="card-title" style={{ fontWeight: "600" }}>
                    {metric}
                  </h6>
                  <p
                    className="card-text"
                    style={{
                      fontSize: "1.25rem",
                      fontWeight: "700",
                      color: this.getColor(metric, avg),
                    }}
                  >
                    {avg !== null ? avg.toFixed(2) : "—"}
                  </p>
                  <p
                    className="text-muted"
                    style={{ fontSize: "0.8rem", margin: 0 }}
                  >
                    from {groupedMetrics[metric].length} samples
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}

export default MetricSummary;
